import useFeatureFlagState from './useFeatureFlagState'

const useIsFeatureFlagEnabled = (flagName: string) =>
  useFeatureFlagState(flagName).isEnabled

export default useIsFeatureFlagEnabled
